// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-page {
  width: 100vw;
  height: 100vh;
}
.chat-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: inherit;
  height: inherit;
}
.chat-bg img {
  width: 100%;
  height: 100%;
  /* object-fit: fill; */
  object-fit: cover;
}
.chat-container {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  /* height: 50vh; */
  height: 58vh;
  padding: 16px 0;
  box-sizing: border-box;
}
.message-list {
  flex: 1 1;
  padding: 0 16px;
  overflow: auto;
}
.message-list .message-item {
  /* width: 100%; */
  width: calc(100vw - 32px);
  font-size: 12px;
  white-space: pre-wrap;
  padding: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  /* user-select: none; */
}
.message-list .message-item:last-child {
  margin-bottom: 0px !important;
}
.message-list .ai {
  background: white !important;
  border-radius: 10px 10px 10px 0 !important;
  min-height: 38px;
  min-width: 64px;
  position: relative;
  padding: 17px 17px;
  padding-right: 43px;
  background: hsla(0,0%,100%,.86) !important;
  border-radius: 22px 22px 22px 0px !important;
  margin-bottom: 17px;
  width: auto;
  display: inline-block;
  font-size: 16px;
  line-height: 27px;
  padding-right: 43px;
  /* user-select: none; */
}
.message-list .user {
  background: linear-gradient(55deg, rgba(232, 204, 254, 0.90) 28.69%, rgba(172, 205, 255, 0.90) 90.93%) !important;
  border-radius: 10px 10px 0 10px !important;
  font-size: 16px;
  line-height: 27px;
  padding: 17px 17px;
  padding-right: 43px;
  /* user-select: none; */
}
.send-button {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 239px;
  height: 48px;
  font-size: 18px;
  font-weight: 400;
  background: linear-gradient(68deg, rgba(154, 195, 255, 0.90) 37.12%, rgba(255, 113, 224, 0.90) 69.43%);
  margin-top: 16px;
  border-radius: 48px;
  margin-bottom: 30px;
  -webkit-user-select: none;
          user-select: none;
}
.send-button-disabled {
  color: #999999;
  background: #DDDDDD !important;
  -webkit-user-select: none;
          user-select: none;
}
.record-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
}
.record-container .record-icon {
  height: 56px;
}
.record-container .record-icon img {
  height: 100%;
}
.record-container .record-tip {
  font-size: 12px;
  color: #CCCCCC;
  margin-top: 134px;
  margin-bottom: 34px;
}
.record-container .record-button {
  position: relative;
  width: 100%;
}
.record-container .record-button > img {
  width: 100%;
}
.record-container .shengbo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 22px;
}
.record-container .shengbo > img {
  width: 100%;
}
.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.4);
}
.bottom-safe-area {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.prologue{
  width: 80%;
  background: rgba(6, 11, 25, 0.78);
  border-radius: 20px;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  padding: 14px;
  margin-bottom: 16px;
}
.prologue-name{
  color: white;
}
.prologue-slogan{
  color: #C0FFFF;
}`, "",{"version":3,"sources":["webpack://./src/mobile/mobile.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,4CAA4C;EAC5C,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iHAAiH;EACjH,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sGAAsG;EACtG,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,8BAA8B;EAC9B,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB","sourcesContent":[".mobile-page {\n  width: 100vw;\n  height: 100vh;\n}\n.chat-bg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: inherit;\n  height: inherit;\n}\n.chat-bg img {\n  width: 100%;\n  height: 100%;\n  /* object-fit: fill; */\n  object-fit: cover;\n}\n.chat-container {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100vw;\n  /* height: 50vh; */\n  height: 58vh;\n  padding: 16px 0;\n  box-sizing: border-box;\n}\n.message-list {\n  flex: 1 1;\n  padding: 0 16px;\n  overflow: auto;\n}\n.message-list .message-item {\n  /* width: 100%; */\n  width: calc(100vw - 32px);\n  font-size: 12px;\n  white-space: pre-wrap;\n  padding: 10px;\n  margin-bottom: 10px;\n  box-sizing: border-box;\n  /* user-select: none; */\n}\n.message-list .message-item:last-child {\n  margin-bottom: 0px !important;\n}\n.message-list .ai {\n  background: white !important;\n  border-radius: 10px 10px 10px 0 !important;\n  min-height: 38px;\n  min-width: 64px;\n  position: relative;\n  padding: 17px 17px;\n  padding-right: 43px;\n  background: hsla(0,0%,100%,.86) !important;\n  border-radius: 22px 22px 22px 0px !important;\n  margin-bottom: 17px;\n  width: auto;\n  display: inline-block;\n  font-size: 16px;\n  line-height: 27px;\n  padding-right: 43px;\n  /* user-select: none; */\n}\n.message-list .user {\n  background: linear-gradient(55deg, rgba(232, 204, 254, 0.90) 28.69%, rgba(172, 205, 255, 0.90) 90.93%) !important;\n  border-radius: 10px 10px 0 10px !important;\n  font-size: 16px;\n  line-height: 27px;\n  padding: 17px 17px;\n  padding-right: 43px;\n  /* user-select: none; */\n}\n.send-button {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 239px;\n  height: 48px;\n  font-size: 18px;\n  font-weight: 400;\n  background: linear-gradient(68deg, rgba(154, 195, 255, 0.90) 37.12%, rgba(255, 113, 224, 0.90) 69.43%);\n  margin-top: 16px;\n  border-radius: 48px;\n  margin-bottom: 30px;\n  user-select: none;\n}\n.send-button-disabled {\n  color: #999999;\n  background: #DDDDDD !important;\n  user-select: none;\n}\n.record-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 3;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.6);\n}\n.record-container .record-icon {\n  height: 56px;\n}\n.record-container .record-icon img {\n  height: 100%;\n}\n.record-container .record-tip {\n  font-size: 12px;\n  color: #CCCCCC;\n  margin-top: 134px;\n  margin-bottom: 34px;\n}\n.record-container .record-button {\n  position: relative;\n  width: 100%;\n}\n.record-container .record-button > img {\n  width: 100%;\n}\n.record-container .shengbo {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 22px;\n}\n.record-container .shengbo > img {\n  width: 100%;\n}\n.loading-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 4;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(255, 255, 255, 0.4);\n}\n.bottom-safe-area {\n  padding-bottom: constant(safe-area-inset-bottom);\n  padding-bottom: env(safe-area-inset-bottom);\n}\n.prologue{\n  width: 80%;\n  background: rgba(6, 11, 25, 0.78);\n  border-radius: 20px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  padding: 14px;\n  margin-bottom: 16px;\n}\n.prologue-name{\n  color: white;\n}\n.prologue-slogan{\n  color: #C0FFFF;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
